import React from "react";
import { observer } from "mobx-react";
import config from "lib/config";
import format, { url } from "lib/format";
import { IconButton } from "lib/components/Button";
import SettingStore from "stores/settings";
import LuvitComponent from "LuvitComponent";
import MenuNode from "./menu-node";
import MyLatestCourses from "./my-latest-courses";
import MainMenuNode from "./main-menu-node";
import "./on-logout";
import SearchBar from "./searchbar";
import NavigationStore from "./Store";

let globalFirstRender = true;
let animTimer = null;
let scrollTimer = null;

$.fn.swipe.excludedElements = ".noSwipe";
const SELECT_MENU_ID = "menu-select";

@observer
export default class LeftMenu extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Menu");
    this.onKeyDown = this.onKeyDown.bind(this);
    this.eventToggleMenu = this.eventToggleMenu.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.onExpandNode = this.onExpandNode.bind(this);
    this.triggerResize = this.triggerResize.bind(this);
  }

  async componentWillMount() {
    const { expanded } = NavigationStore;
    let firstRender = false;
    if (animTimer) clearTimeout(animTimer);

    await SettingStore.init();

    if (globalFirstRender) {
      firstRender = true;
      globalFirstRender = false;
    }

    const isBt = SettingStore.isBt();

    this.setState({ expanded, firstRender, isBt });
    NavigationStore.reload();
  }

  onExpandNode(node) {
    let id = node.itemId;
    if (id === 1004 || id === 1007) return;
    if (
      id === this.state.expandedId &&
      NavigationStore.expanded &&
      node.parentId === -1
    ) {
      id = 1;
    }

    const nodesArray = Array.isArray(NavigationStore.nodes)
      ? NavigationStore.nodes
      : Object.values(NavigationStore.nodes || {});
    const child = nodesArray.find((n) => n.parentId === node.itemId);
    if (!child) {
      NavigationStore.activateNode(id);
    } else {
      NavigationStore.expandToggle(true);
    }

    this.setState({ expandedId: id });
  }

  onKeyDown(e) {
    if (!(e.ctrlKey && e.shiftKey)) {
      return;
    }

    let isOverridden = false;

    if (e.keyCode === 13) {
      NavigationStore.expandToggle(!NavigationStore.expanded);
      isOverridden = true;
    }
    if (isOverridden) {
      e.preventDefault();
    }
  }

  componentDidMount() {
    if (luvit.IsTouchDevice()) {
      setTimeout(
        () =>
          $(".portal.menu, body").swipe({
            swipeLeft: () => {
              NavigationStore.expandToggle(false);
            },
            excludedElements: "select,input,textarea,label",
          }),
        50,
      );
    }

    $(document.body).on("click", (e) => {
      if (!NavigationStore.expanded) return;
      if (window.matchMedia("(max-width: 1025px)").matches)
        NavigationStore.expandToggle(true);
      if (
        $(e.target).closest(this.refs.root).addBack(this.refs.root).length > 0
      )
        return;
    });

    $(window).on("keydown", this.onKeyDown);

    this.updateContentAlignement(NavigationStore.expanded);
  }

  componentWillUnmount() {
    if (luvit.IsTouchDevice()) {
      $(".portal.menu").swipe("destroy");
    }

    $(window).off("keydown", this.onKeyDown);

    animTimer = setTimeout(() => {
      globalFirstRender = true;
    }, 300);
  }

  updateContentAlignement(expanded) {
    document.body.classList.toggle("leftmenu-contracted", !expanded);
    document.body.classList.toggle("leftmenu-expanded", !!expanded);

    const pageContent = document.querySelector(".page-content.maindiv");
    const headerWrapper = document.querySelector(".header-wrapper");
    if (pageContent && headerWrapper) {
      if (expanded) {
        pageContent.classList.add("pushed");
        headerWrapper.classList.add("pushed");
      } else {
        pageContent.classList.remove("pushed");
        headerWrapper.classList.remove("pushed");
      }
    }
  }

  onLogout() {
    jQuery(document).trigger("logout");
    location.href = format.url("/logout");
  }

  componentWillUpdate(nextProps, nextState) {
    // on toggle menu
    if (this.state) {
      if (NavigationStore.expanded !== this.state.expanded) {
        this.setState({ expanded: NavigationStore.expanded });
        this.updateContentAlignement(NavigationStore.expanded);
      }
    }
  }

  eventToggleMenu(open) {
    return (e) => {
      e.stopPropagation();
      this.toggleMenu(open);
    };
  }

  toggleMenu(open) {
    if (typeof open === "boolean" && open === NavigationStore.expanded) {
      return;
    }

    NavigationStore.expandToggle(typeof open === "boolean" ? open : undefined);

    setTimeout(this.triggerResize, 100);
  }

  triggerResize() {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  }

  scrollDidMount = (node) => {
    if (node) {
      node.scrollTop = sessionStorage.getItem("leftMenuScroll") || 0;
      node.addEventListener("scroll", (e) => {
        if (e.target.id !== SELECT_MENU_ID) {
          if (scrollTimer) {
            clearTimeout(scrollTimer);
          }
          scrollTimer = setTimeout(
            () => sessionStorage.setItem("leftMenuScroll", node.scrollTop),
            500,
          );
        }
      });
    }
  };

  doRender() {
    const displayMenuSearchbar =
      SettingStore.getSettingValue("showsearchfieldinmenu") === "1";
    const displayPortalOverviewLink =
      SettingStore.getSettingValue("showportaloverviewinmenu") === "1";
    const showMyCoursesInLeftMenu =
      SettingStore.getSettingValue("showmycoursesinleftmenu") === "1";
    const expanded = NavigationStore.expanded;
    const labelMenuToggleButton = `${
      expanded ? this.l("collapsemenu") : this.l("expandmenu")
    }`;

    const isReady = NavigationStore.ready;
    let addClasses = NavigationStore.expanded ? "selected" : "";
    addClasses += this.state.firstRender ? " animation" : "";

    if (!isReady) {
      return (
        <div className={"portal menu " + addClasses}>
          <div className="menu-column scroll-lock" />
        </div>
      );
    }

    return (
      <>
        <nav
          className={"portal menu " + addClasses}
          data-testid="leftmenu-wrapper"
          role="navigation"
        >
          <IconButton
            onClick={this.eventToggleMenu()}
            icon="icon-menu menu-icon"
            id="ToggleIcon"
            overridefocus="--colorLeftMenuFocus"
            label={labelMenuToggleButton}
          />
          <ul
            ref={(ul) => (this.root = ul)}
            id="main-navigation-list"
            className="menu-column scroll-lock"
            ref={this.scrollDidMount}
            aria-label={this.l("mainmenu")}
            role="menu"
          >
            <li
              className="menu-searchbar-li flex flex-space-b align-c menu-row"
              role="none"
            >
              {displayMenuSearchbar && (
                <SearchBar
                  courses={NavigationStore.courses}
                  menu={NavigationStore.nodes}
                  ref={(searchBar) => (this.searchBar = searchBar)}
                />
              )}
            </li>
            {displayPortalOverviewLink && this.renderPortalMenu()}
            {showMyCoursesInLeftMenu && (
              <MyLatestCourses
                courses={NavigationStore.courses}
                expanded={expanded}
                onExpand={this.toggleMenu}
              />
            )}
            {this.renderMainMenu()}
            {!config.hideLogout ? (
              <li className="menu-expandlist-header" role="menuitem">
                <a
                  href={format.url("/logout")}
                  aria-label={this.l("logout")}
                  title={this.l("logout")}
                >
                  <div className="icon-logout" aria-hidden="true">
                    &nbsp;&nbsp;
                  </div>
                  <span>{this.l("logout")}</span>
                </a>
              </li>
            ) : (
              ""
            )}
          </ul>
        </nav>
      </>
    );
  }

  renderMainMenu() {
    const nodesArray = Array.isArray(NavigationStore.nodes)
      ? NavigationStore.nodes
      : Object.values(NavigationStore.nodes || {});
    const children = nodesArray
      .filter((v) => v.parentId === -1)
      .sort((a, b) => {
        if (a.order === undefined && b.order === undefined) {
          return 0;
        }
        if (a.order === undefined) {
          return 1;
        }
        if (b.order === undefined) {
          return -1;
        }
        return a.order - b.order;
      });
    return children.map((c) => (
      <MainMenuNode
        key={c.itemId}
        expandable={NavigationStore.expanded}
        onExpand={this.onExpandNode}
        activeMenuId={this.state.expandedId || NavigationStore.active}
        highlightMenuId={NavigationStore.active}
        menu={NavigationStore.nodes}
        node={c}
        isBt={this.state.isBt}
      />
    ));
  }

  renderPortalMenu() {
    return (
      <MenuNode
        type="menu-expandlist-header"
        url={url("/activitycentre/activitycentre.aspx")}
        title={
          this.state.isBt ? this.l("information") : this.l("portaloverview")
        }
        aria-label={
          this.state.isBt ? this.l("information") : this.l("portaloverview")
        }
        icon="icon-home"
        highlight={NavigationStore.active === "1"}
        expanded={NavigationStore.expanded}
      />
    );
  }
}
